import translations from 'src/internationalisation/translation-map.json';
import { distributionTypes, estimateTypes } from 'src/enums/tasks';

type TTranslate = (key: string) => string;

type TBranchRowParam = {
  key: string;
  name: string;
  quantity?: string;
};

type TGetBranchRowsParams = {
  t: TTranslate;
  estimateType: number;
  distributionType: string;
};

export const getBranchRowsParams = ({ t, estimateType, distributionType }: TGetBranchRowsParams): TBranchRowParam[] => {
  const quantity = estimateType === estimateTypes.OPERATION_TIME ? 'hr' : 'm/hr';
  const distributionFieldMap: Record<string, TBranchRowParam[]> = {
    [distributionTypes.PERT]: [
      {
        key: 'min',
        name: t(translations.minimum),
        quantity,
      },
      {
        key: 'most',
        name: t(translations.mostLikely),
        quantity,
      },
      {
        key: 'max',
        name: t(translations.maximum),
        quantity,
      },
    ],
    [distributionTypes.UNIFORM]: [
      {
        key: 'min',
        name: t(translations.minimum),
        quantity,
      },
      {
        key: 'max',
        name: t(translations.maximum),
        quantity,
      },
    ],
    [distributionTypes.SPIKE]: [
      {
        key: 'most',
        name: t(translations.mostLikely),
        quantity,
      },
    ],
  };

  return [
    {
      key: 'name',
      name: t(translations.name),
    },
    {
      key: 'certainty',
      name: t(translations.probability),
      quantity: '%',
    },
    ...distributionFieldMap[distributionType],
    ...(estimateType === estimateTypes.OPERATION_SPEED
      ? [
          {
            key: 'from',
            name: t(translations.from),
            quantity: 'm',
          },
          {
            key: 'to',
            name: t(translations.to),
            quantity: 'm',
          },
        ]
      : []),
  ];
};

export const getBranchHeaderRow = (rowsParams: TBranchRowParam[]) =>
  rowsParams.map(({ name }) => ({
    value: name,
  }));

export const getBranchUnitRow = (rowsParams: TBranchRowParam[]) =>
  rowsParams.map(({ quantity }) => {
    if (!quantity) return {};
    return {
      value: quantity,
    };
  });
